import axios from "axios";
import { cwslapi } from "@/api/index.js";
let publicUrl = {
  //loginPage:'https://wx.qtthtech.com/#/home',
  loginPage: "/",
  shopHomeUrl: "http://shop.818long.com/#/shop",
  shopBlindBoxUrl: "http://shop.818long.com/#/shop/blindBox",
  shopIntegralUrl: "http://shop.818long.com/#/shop?type=integralArea",
  shopWarehouseUrl: "http://shop.818long.com/#/shop/personWarehouse",
  emotion: "https://download-wx.qtthtech.com/shop/web/emotion/",
};
const init = () => {
  const baseUrl = cwslapi.defaults.baseURL;

  if (baseUrl.indexOf("109.244.44.238:8000") == -1) {
  } else {
    (publicUrl.shopHomeUrl = "http://testshop-mf.818long.com/#/shop"),
      (publicUrl.shopBlindBoxUrl =
        "http://testshop-mf.818long.com/#/shop/blindBox"),
      (publicUrl.shopIntegralUrl =
        "http://testshop-mf.818long.com/#/shop?type=integralArea"),
      (publicUrl.shopWarehouseUrl =
        "http://testshop-mf.818long.com/#/shop/personWarehouse");
  }
};
export { publicUrl, init };
